import posthog from 'posthog-js';
import { hasAnalyticsConsent } from './consent';

type InitPostHogOptions = {
  appName: string;
  apiKey?: string | null;
  apiHost?: string | null;
  autocapture?: boolean;
  capturePageview?: boolean;
};

let initialized = false;

export function initPostHog(options: InitPostHogOptions): boolean {
  const apiKey = options.apiKey?.trim();
  if (!apiKey || typeof window === 'undefined') return false;
  if (initialized) return true;

  posthog.init(apiKey, {
    api_host: options.apiHost?.trim() || 'https://eu.posthog.com',
    autocapture: options.autocapture ?? false,
    capture_pageview: options.capturePageview ?? false,
    persistence: 'localStorage+cookie',
    loaded(instance) {
      instance.register({
        app: options.appName,
      });
    },
  });

  if (!hasAnalyticsConsent()) {
    posthog.opt_out_capturing();
  }

  initialized = true;
  return true;
}

export function identifyAnalyticsUser(
  userId: string,
  properties?: Record<string, string | number | boolean | null | undefined>,
): void {
  if (!initialized || !hasAnalyticsConsent()) return;
  posthog.identify(userId, properties);
}

export function captureAnalyticsEvent(
  event: string,
  properties?: Record<string, string | number | boolean | null | undefined>,
): void {
  if (!initialized || !hasAnalyticsConsent()) return;
  posthog.capture(event, properties);
}

export function setAnalyticsConsent(granted: boolean): void {
  if (!initialized) return;
  if (granted) posthog.opt_in_capturing();
  else posthog.opt_out_capturing();
}

export function resetAnalytics(): void {
  if (!initialized) return;
  posthog.reset();
}
